<template>
    <div style="width: 100%">
        <el-container>
            <!--左侧一级导航栏列表-->
            <el-aside width="300px">
                <div class="left_nav_tab">
                    <ul class="left_nav_tab_ul" :class="rootColumnId===item.id?'left_nav_tab_ul-active':''"
                        v-for="(item,index) in rootColumnList" :key="index">
                        <router-link :to="'/article/rootColumn/' + item.id">
                            <li class="left_nav_tab_ul_li" @click="getNavId(item.id)">
                                <a>{{item.label}}</a>
                            </li>
                        </router-link>
                    </ul>
                </div>
            </el-aside>

            <!--中间部分,既显示文章列表，也显示文章详情，通过router-view实现-->
            <el-main style="padding: 0px">
                <router-view class="mid-main" v-if="isRouterAlive"></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import {getRootColumn} from "@/api/get";

    export default {
        name: "Article",

        provide() {
            return {
                reload: this.reload
            }
        },

        data() {
            return {
                rootColumnId: 0,
                rootColumnList: [],
                route: [],

                isRouterAlive: true
            }
        },
        watch: {
            /*监听id变化*/
            // rootColumnId:{
            //     handler(){
            //         this.$router.push('/article/rootColumn/'+this.rootColumnId);
            //     },
            //     immediate: true
            // },
            /*监听路由变化*/
            $route: {
                handler() {
                    //获取当前路由
                    this.router = this.$route.fullPath;
                    this.route = this.router.split("/")
                    //找出rootColumn和detail
                    // console.log("router2"+this.route[2])

                    //文章详情页点击头部的article按钮
                    if (this.route[3] === ":rootColumnId") {
                        this.$router.push('/article/rootColumn/' + this.rootColumnId);
                    }
                },
                immediate: true
            }
        },
        created() {
            // 获取左侧导航栏
            this.getRootColumn();
        },
        methods: {
            reload() {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            },


            // 获取左侧导航栏
            getRootColumn() {
                getRootColumn().then(response => {
                    this.rootColumnList = response.data
                    this.rootColumnId = response.data[0].id

                    if (this.route[2] === "rootColumn") {
                        this.$router.push('/article/rootColumn/' + this.rootColumnId);
                    }
                });
            },
            // 选中颜色
            getNavId(id) {
                this.rootColumnId = id
            }
        }
    }
</script>

<style scoped>
    /*左侧导航栏*/
    .left_nav_tab_ul {
        list-style: none;
        margin: 0px;
        padding: 0px;
    }

    .left_nav_tab_ul_li {
        /*margin: 12px;*/
        /*margin-left: 10px;*/
    }

    .left_nav_tab_ul_li a {
        font-size: 16px;
        color: #000;
        display: inline-block;
        text-align: center;
        list-style: none;
        margin: 12px 12px 12px 30px;
    }

    .left_nav_tab_ul_li:hover {
        background: #E4E6E9;
        border-radius: 9px;
    }

    .left_nav_tab_ul-active li {
        background: #E4E6E9;
        color: white;
    }

    /*中间部分*/
    .mid-main {
        /*width: 100%;*/
        margin: auto 10px;
    }
</style>
